import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../Map.module.css';
import logoSrc from '../../../assets/red-green-tampere.svg';

const AppTitle = ({ isRoutingMode }) => {
    const { t } = useTranslation();
    return (
        <div className={`${styles.AppTitleContainer} ${isRoutingMode ? styles.routingMode : ''}`}>
            <div>
                <img className={styles.AppTitleLogo} src={logoSrc} alt="Punavihreä Tampere" />
            </div>
            <div className={styles.AppTitleTextContainer}>
                <div className={styles.AppTitleText}>
                    {t('app.title_1')}
                </div>
                <div className={styles.AppTitleTextLarge}>
                    {t('app.title_2')}
                </div>
            </div>
        </div>
    );
};

export default AppTitle;
